// TargetLeaguesCard — sidebar card listing player's target leagues with
// tier labels (T1 highest). Empty list → hide the card entirely; sidebar
// can be shorter when there's no signal worth showing.

import { Target } from 'lucide-react'

interface TargetLeague {
  id: string
  league_name: string
  country: string | null
  tier: 'T1' | 'T2' | 'T3'
  notes: string | null
}

const TIER_LABEL: Record<TargetLeague['tier'], string> = {
  T1: 'Tier 1',
  T2: 'Tier 2',
  T3: 'Tier 3',
}

const TIER_STYLE: Record<TargetLeague['tier'], string> = {
  T1: 'bg-hoop-amber-bg text-hoop-amber',
  T2: 'bg-hoop-accent-light text-hoop-accent',
  T3: 'bg-hoop-bg text-hoop-text-2',
}

export default function TargetLeaguesCard({
  leagues,
}: {
  leagues: TargetLeague[]
}) {
  if (leagues.length === 0) return null

  return (
    <section className="bg-hoop-surface border border-hoop-border rounded-2xl p-4">
      <h2 className="text-[11px] font-semibold uppercase tracking-wider text-hoop-accent mb-3 flex items-center gap-1.5">
        <Target className="w-3 h-3" />
        Target Leagues
      </h2>

      <ul className="space-y-2">
        {leagues.map((l) => (
          <li key={l.id} className="flex items-start justify-between gap-2 text-xs">
            <div className="min-w-0">
              <div className="font-medium text-hoop-text truncate">
                {l.league_name}
              </div>
              {l.country && (
                <div className="text-[10px] text-hoop-text-3">
                  {l.country}
                </div>
              )}
            </div>
            <span
              className={`inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-semibold flex-shrink-0 ${TIER_STYLE[l.tier]}`}
              title={TIER_LABEL[l.tier]}
            >
              {l.tier}
            </span>
          </li>
        ))}
      </ul>
    </section>
  )
}
